import { gql } from "@apollo/client";

export const GET_ALL_MOTIVO_ALTA_PACIENTE = gql`
    query getAllMotivoAltaPaciente {
        allMotivoAltaPaciente {
            idMotivoAltaPaciente
            descripcion
            codigo
        }
    }
`;

export const adaptMotivoAltaPaciente = (motivo) => {
  return {
    id: motivo?.idMotivoAltaPaciente,
    displayName: motivo?.descripcion
  };
};

export const adaptMotivoAltaPacienteArray = (motivos) => {
  return structuredClone(motivos)?.
  map((motivo) => adaptMotivoAltaPaciente(motivo));
};